<template>
  <div class="card-block" v-if="currentPage === 'admin'">
    <h3 class="card-title">
      Transfer
    </h3>
    <p class="card-text">
      <form v-on:submit.prevent="onSubmit">
        <div class="row">
          <div class="col-md-4 col-xs-12">
            <alert v-show="showSuspendAlert"
              alertClass="m-b-25 alert-dismissible"
              v-bind:type="`${ (successSuspendResponse) ? 'success' : 'danger' }`"
              v-bind:iconClass="`${ (successSuspendResponse) ? 'md-check' : 'md-close' }`">
              <span v-if="successSuspendResponse">{{successSuspendResponse}}</span>
              <span v-else-if="errorSuspendResponse">{{errorSuspendResponse}}</span>
            </alert>
            <form-group>
              <label for="team">Choose Reseller <span class="red-600">*</span></label>
              <v-select v-model="newReseller" :options="filterItems"></v-select>
            </form-group>
          </div>
        </div>
        <button type="submit" class="btn btn-success">
          Submit <span class="glyphicon"></span>
        </button>
      </form>
    </p>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import axios from 'axios';
import vSelect from 'vue-select';
import { Validator } from 'vee-validate';
import FormGroup from 'components/forms/FormGroup';
import Alert from 'components/Alert';
import LoadingIndicator from 'components/LoadingIndicator';
import TeamTerminate from 'components/teams/TeamTerminate';
import MembersBrowser from 'components/members/MembersBrowser';

export default {
  components: {
    FormGroup,
    Alert,
    LoadingIndicator,
    MembersBrowser,
    TeamTerminate,
    vSelect,
  },
  props: [
    'team',
  ],
  watch: {
    'team.name': function() {
      if (this.formErrors.has('name')) {
        this.formErrors.remove('name');
      }
    },
  },
  computed: {
    ...mapGetters([
      'currentUser',
    ]),
    baseURL: function() {
      return process.env.BASE_URL;
    },
    isLoading: function () {
      return this.isMembersBrowserLoading;
    },
    currentPage: function () {
      if (this.currentUser.team.is_superadmin) {
        return 'admin';
      } else if (this.currentUser.team.is_reseller) {
        return 'reseller';
      }
    },
    filterItems: function () {
      const temp = [];
      this.teams.forEach((item) => {
        temp.push({ label: item.namespace, value: item.id });
      });
      return temp;
    },
  },
  created: function() {
    this.isLoading = true;
    this.isMembersBrowserLoading = false;
    this.validator = new Validator();
    this.validator.attach('name', 'required|max:72', { prettyName: 'Team Display name' });

    this.$set(this, 'formErrors', this.validator.errorBag);
  },
  mounted: function() {
    this.fetchTeams();
  },
  data: function () {
    return {
      showGeneralAlert: false,
      errorGeneralResponse: null,
      successGeneralResponse: null,
      showSuspendAlert: false,
      errorSuspendResponse: null,
      successSuspendResponse: null,
      validator: null,
      formErrors: null,
      currentSuspendMode: '',
      isMembersBrowserLoading: false,
      teams: [],
      newReseller: null,
    };
  },
  methods: {
    onSubmitGeneral: function () {
      // hide alert
      this.showGeneralAlert = false;

      this.validator.validateAll({
        name: this.team.name,
      })
      .then((success) => {
        if (!success) {
          return;
        }

        const namespace = this.team.namespace;

        this.isSubmiting = true;
        axios.put(`/api/teams/${namespace}`, {
          name: this.team.name,
        })
        .then((response) => {
          this.isSubmiting = false;
          this.successGeneralResponse = this.$t('team.response.success');
          this.errorGeneralResponse = null;
          this.team = response.data;
          this.showGeneralAlert = true;

          this.$store.dispatch('updateCurrentUserTeam', this.team);
        })
        .catch((error) => {
          this.isSubmiting = false;

          if (error.response.status === 422) {
            this.errorGeneralResponse = this.$t('team.response.failed');
            this.formErrors.addAll(error.response.data);
          } else {
            this.errorGeneralResponse = this.$t('team.response.defaultFailed');
          }
          this.showGeneralAlert = true;
        });
      })
      .catch(() => {
        this.isSubmiting = false;
      });
    },
    onSubmitSuspendStatus: function () {
      this.showSuspendAlert = false;

      axios.post(`api/admin/setsuspend`, {
        namespace: this.team.namespace,
        mode: this.currentSuspendMode,
        suspend_reason: this.teamSuspend.suspend_reason,
      })
      .then((response) => {
        this.successSuspendResponse = this.$t('team.response.success');
        this.teamSuspend = response.data;
        this.updateSupsendMode();

        this.errorSuspendResponse = null;
        this.showSuspendAlert = true;
      })
      .catch((error) => {
        // TODO: show error message from api
        if (error.response.status === 422) {
          this.errorSuspendResponse = this.$t('team.response.failed');
          this.formErrors.addAll(error.response.data);
        } else {
          this.errorSuspendResponse = this.$t('team.response.defaultFailed');
        }
        this.showSuspendAlert = true;
      });
    },
    onSubmitDeactivateStatus: function () {
      this.showSuspendAlert = false;

      axios.post(`api/admin/setdeactivate`, {
        namespace: this.team.namespace,
        mode: this.currentDeactivateMode,
      })
      .then((response) => {
        this.successSuspendResponse = this.$t('team.response.success');
        this.teamSuspend = response.data;
        this.updateSupsendMode();

        this.errorSuspendResponse = null;
        this.showSuspendAlert = true;
      })
      .catch((error) => {
        // TODO: show error message from api
        if (error.response.status === 422) {
          this.errorSuspendResponse = this.$t('team.response.failed');
          this.formErrors.addAll(error.response.data);
        } else {
          this.errorSuspendResponse = this.$t('team.response.defaultFailed');
        }
        this.showSuspendAlert = true;
      });
    },
    fetchTeams: function() {
      axios.get(`/api/teams`)
      .then((response) => {
        this.teams = response.data.data;
        this.isLoading = false;
      })
      .catch(() => {
        this.isLoading = false;
        // error
      });
    },
    changePayPlan: function(value) {
      this.team.pay_plan = value;
    },
    membersBrowserLoadChanged: function(value) {
      this.isMembersBrowserLoading = value;
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// TeamTransfer.vue?9be7d96a